export const CSS_VAR_FONT_SIZE = '--font-size';
export const CSS_VAR_FONT_WEIGHT = '--font-weight';
export const CSS_VAR_GAP = '--gap';
export const CSS_VAR_DESKTOP_SCALE = '--desktop-scale';
export const CSS_VAR_ASPECT_RATIO = '--aspect-ratio';
export const CSS_VAR_TOP = '--top';
export const CSS_VAR_BOTTOM = '--bottom';
export const CSS_VAR_WIDTH = '--width';
export const CSS_VAR_LINE_HEIGHT = '--line-height';
export const CSS_VAR_COLOR = '--color';
export const CSS_VAR_ANIMATION_DELAY = '--animation-delay';
export const CSS_VAR_SCROLL = '--scroll';
